<template>
    <div class="fw-billing">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="fwb-top">
            <div class="fwbt-s">
                <div class="fwbt-item">
                    <span class="fwbt-t">{{serviceName}}</span>
                    <span class="fwbt-b">服务号</span>
                </div>
                <div class="fwbt-item" style="border-left: #EEEEEE solid 1px">
                    <span class="fwbt-t1" @click="toMember">选择会员</span>
                    <span class="fwbt-b">操作</span>
                </div>
            </div>
            <div class="fwbt-x">
                <div class="fwbt-item1" style="border-left: 0px">
                    <span class="fwbt-t1" v-if="member&&member.id">{{member.memberName}}</span>
                    <span class="fwbt-t1" v-if="!member||!member.id">散客</span>
                    <span class="fwbt-b">客户名称</span>
                </div>
                <div class="fwbt-item1" v-if="mbCard&&mbCard.id">
                    <span class="fwbt-t1">{{mbCard.cardName}}</span>
                    <span class="fwbt-b">{{mbCard.balance}}</span>
                </div>
                <div class="fwbt-item2" v-if="member&&member.id" @click="toMdItems">
                    套餐
                </div>
                <div class="fwbt-item2" v-if="member&&member.id" @click="toScItems">
                    商城
                </div>
            </div>
        </div>
        <div class="fw-kdtype">
            <div class="fw-leibie">
                <span :class="{'lbActive':lbIndex==0}">项目</span>
                <span :class="{'lbActive':lbIndex==1}"></span>
                <span :class="{'lbActive':lbIndex==2}"></span>
                <span :class="{'lbActive':lbIndex==3}"></span>
            </div>
            <div class="fw-gwitems">
                <div class="fw-gwitems-f">
                          <span class="fw-cats" :class="{'active':index==tabIndex}" v-for="(cat,index) in list"
                                @click="getGwItems(index,cat)">
                               {{cat.catName}}
                          </span>
                </div>
                <div class="fw-gwitems-r">
                    <div class="fwgr-item" v-for="item in items">
                        <div class="fwgr-item-info">
                            <span class="mc">{{item.itemName}}</span>
                            <span class="nr">内容：{{item.fwContent}}</span>
                            <span class="jg">¥{{item.price}}</span>
                        </div>
                        <el-button size="mini" @click="toChoose(item)">选择</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="fw-btn">
            <div class="mingxi" @click="toMx">
                <div class="mingxi-text">
                    <span style="font-size: 13px">明细查看</span>
                    <span style="margin-top: 5px;font-size: 20px">
                    <span style="font-size: 10px;margin-right: 5px">¥</span>{{total}}</span>
                </div>
            </div>
            <div class="baocun" @click="saveOrder">
                <span class="baocun-btn">保存并返回</span>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.itemName}}</span>
                    <span class="nr">内容：{{item.fwContent}}</span>
                    <span class="jg">¥{{item.price}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">调整价格</span>
                        <el-input v-model="item.total" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" @click="setLEmp(emp,1)"
                                  @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" @click="setLEmp(emp,2)"
                                  @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" @click="setLEmp(emp,3)"
                                  @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;height: 32px;font-size: 18px;background-color: #2b94ff;text-align: center;color: #ffffff;line-height: 32px"
                 @click="addData">
                确定
            </div>
        </van-popup>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 90%;">
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <span style="font-size: 15px">服务号:
                        <span style="color:red;font-size: 13px">{{serviceName}}</span>
                    </span>
                    <div class="fw-mx-nr">
                        <span style="height: 32px;font-size: 15px;line-height: 32px" v-if="member&&member.id">{{member.memberName}}</span>
                        <span style="height: 32px;font-size: 15px;line-height: 32px"
                              v-if="!member||!member.id">散客</span>
                        <!--                        <span style="font-size: 12px;">2024-02-29</span>-->
                        <div class="fw-mx-items">
                            <div class="fw-mx-item" v-for="(item,index) in datas">
                                <div class="fwmxi-info">
                                    <span class="fm-name">{{item.itemName}}</span>
                                    <span class="fm-jg">¥{{item.price}}</span>
                                    <span class="fm-num">x1</span>
                                    <span class="fm-btn" @click="delData(index)">删除</span>
                                </div>
                                <span class="mxemp" v-if="fName">{{fName}}: {{item.femp.empName}} </span>
                                <span class="mxemp" v-if="sName">{{sName}}: {{item.semp.empName}}</span>
                                <span class="mxemp" v-if="tName">{{tName}}: {{item.temp.empName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;">
            <div style="padding: 15px;margin-top: 12px;display: flex;flex-direction: row;justify-content: center;align-items: center">
                <van-search
                        v-model="money"
                        placeholder="要搜索的手机号 / 姓名"
                        shape="round"
                        style="width: 70%;"
                >
                </van-search>
                <span class="soubtn" @click="onSearch">搜索</span>
                <span class="soubtn" @click="sanke">散客</span>
            </div>
            <div style="display: flex;flex-direction: column;border-top: #dddddd solid 1px;padding-top: 5px;padding: 10px">
                <el-card class="box-card" v-for="item in members">
                    <div slot="header" class="clearfix">
                        <div style="display: flex;flex-direction: row;height: 25px;text-align: center;font-size: 12px">
                            <span style="width: 10%">
                                 <img v-if="item.headPortrait" :src="item.headPortrait"
                                      style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==0" src="./../../assets/nan.png"
                                     style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==1" src="./../../assets/nan.png"
                                     style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==2" src="./../../assets/nv.png"
                                     style="height: 25px;width: 25px">
                            </span>
                            <span style="width: 23%;line-height: 25px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.memberName}}</span>
                            <span style="width: 11%;line-height: 25px">
                                <span v-if="item.sex == 0">未知</span>
                                <span v-if="item.sex == 1">男</span>
                                <span v-if="item.sex == 2">女</span>
                            </span>
                            <span style="width: 23%;line-height: 25px">{{ item.phone }}</span>
                            <span style="width: 23%;line-height: 25px"> {{ item.deptName }}</span>
                        </div>
                        <el-button style="float: right; padding: 3px 0;margin-top: -23px;font-size: 13px" type="text"
                                   @click="setMember(item)">
                            选择
                        </el-button>
                    </div>
                    <div class="card-item" v-if="item.memberCards" v-for="card in item.memberCards">
                        <div style="width: 45%;display: flex;flex-direction: column;justify-content: center;">
                            <span style="line-height: 20px"> {{card.cardName}} ( {{card.itemDiscount}}折 )</span>
                            <span style="line-height: 20px">卡号: {{card.mcNo}}</span>
                        </div>
                        <div style="width: 45%;;display: flex;flex-direction: column">
                            <span style="line-height: 20px">卡余额 : ¥{{card.balance}}</span>
                            <span style="line-height: 20px">赠送金 : ¥{{card.giveBalance}}</span>
                        </div>
                        <el-button style="width: 10%;font-size: 13px;text-align: right" type="text"
                                   @click="setMember(item,card)">
                            选择
                        </el-button>
                    </div>
                </el-card>
            </div>
        </van-popup>
        <van-popup v-model="tcempShow" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{tcItem.itemName}}</span>
                    <span class="jg">¥{{tcItem.price}}</span>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" @click="setLEmp(emp,1)"
                                  @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" @click="setLEmp(emp,2)"
                                  @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" @click="setLEmp(emp,3)"
                                  @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addTcData"> 确定</div>
        </van-popup>
        <van-popup v-model="tcShow" position="bottom" lock-scroll :close-on-click-overlay="false"
                   style="height: 100%;">
              <span class="md-bt">
                    <span>套餐管理</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="tcmb">
              <span style="width: 10%">
               <img v-if="member.headPortrait" :src="member.headPortrait" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==0" src="./../../assets/nan.png" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==1" src="./../../assets/nan.png" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==2" src="./../../assets/nv.png" class="img-mb"/>
               </span>
                <span style="width: 23%;line-height: 25px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{member.memberName}}</span>
                <span style="width: 11%;line-height: 25px">
                 <span v-if="member.sex == 0">未知</span>
                 <span v-if="member.sex == 1">男</span>
                 <span v-if="member.sex == 2">女</span>
                 </span>
                <span style="width: 23%;line-height: 25px">{{ member.phone }}</span>
                <span style="width: 23%;line-height: 25px"> {{ member.deptName }}</span>
            </div>
            <div style="margin-top: 15px">
                <div class="tcs" v-for="item in miNames">
                    <span style="height: 23px;line-height: 23px;">{{item.ascriptionName}}</span>
                    <div class="tcitems">
                        <div class="tcitem" v-for="it in item.memberItems">
                            <span style="width: 60%">{{it.itemName}}</span>
                            <span style="width: 20%">x{{it.total-it.uses}}</span>
                            <span class="xzbtn" @click="toTc(it)">选择</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="scShow" position="bottom" lock-scroll :close-on-click-overlay="false"
                   style="height: 100%;">
              <span class="md-bt">
                    <span>商城套餐</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="tcmb">
              <span style="width: 10%">
               <img v-if="member.headPortrait" :src="member.headPortrait" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==0" src="./../../assets/nan.png" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==1" src="./../../assets/nan.png" class="img-mb"/>
               <img v-if="!member.headPortrait&&member.sex==2" src="./../../assets/nv.png" class="img-mb"/>
               </span>
                <span style="width: 23%;line-height: 25px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{member.memberName}}</span>
                <span style="width: 11%;line-height: 25px">
                 <span v-if="member.sex == 0">未知</span>
                 <span v-if="member.sex == 1">男</span>
                 <span v-if="member.sex == 2">女</span>
                 </span>
                <span style="width: 23%;line-height: 25px">{{ member.phone }}</span>
                <span style="width: 23%;line-height: 25px"> {{ member.deptName }}</span>
            </div>
            <div style="margin-top: 15px">
                <div class="tcs" v-for="item in shopNames">
                    <span style="height: 23px;line-height: 23px;">{{item.name}}</span>
                    <div class="tcitems">
                        <div class="tcitem" v-for="it in item.memberItems">
                            <span style="width: 60%">{{it.itemName}}</span>
                            <span style="width: 20%">x{{it.total-it.uses}}</span>
                            <span class="xzbtn" @click="toSc(it)">选择</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '开单选项',
                deptId: '',
                token: '',
                active: 0,
                serviceNo: '',
                serviceName: '',
                list: [],
                gwJb: {},
                room: {},
                tabIndex: 0,
                items: [],
                lbIndex: '0',

                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                datas: [],
                total: 0,

                mxShow: false,
                mbShow: false,
                money: '',
                members: [],
                member: {},
                mbCard: {},

                tcShow: false,
                scShow: false,
                shopNames: [],
                miNames: [],
                tcempShow: false,
                tcItem: {},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.taskId = this.$route.query.taskId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getServiceNo()
            this.getFwEmps()
            await this.getCatItems()
            this.title = this.title + ' / ' + this.gwJb.gradeName
        },
        methods: {
            async getServiceNo() {
                let res = await this.$get("/fw/getFwServiceNo", {taskId: this.taskId, deptId: this.deptId});
                this.serviceName = res.serviceName
                this.serviceNo = res.serviceNo
            },
            toMember() {
                this.money = ''
                this.members = []
                this.mbShow = true
            },
            async onSearch(page) {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let currentPage = 1;
                let data = {
                    deptId: this.deptId,
                    name: this.money,
                    isDel: 0,
                    size: 10,
                    currentPage,
                };
                let res = await this.$get("/fw/getFwMemberForPage", data);
                if (res.code == 200) {
                    this.members = res.dataSet.list;
                }
            },
            sanke() {
                this.member = {}
                this.mbCard = {}
                //切换会员卡的时间 重新计算添加项目的价格
                var total = 0;
                this.datas.forEach(item => {
                    this.setPrice(item)
                    total = parseFloat(total) + parseFloat(item.price)
                })
                this.total = total.toFixed(1)
                this.mbShow = false
            },

            setMember(mb, card) {
                this.member = mb
                this.mbCard = card
                //切换会员卡的时间 重新计算添加项目的价格
                var total = 0;
                this.datas.forEach(item => {
                    this.setPrice(item)
                    total = parseFloat(total) + parseFloat(item.price)
                })
                this.total = total.toFixed(1)
                this.mbShow = false
            },

            addData() {
                let fEmp = {}
                let sEmp = {}
                let tEmp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            fEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            sEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            tEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                let item = this.item
                this.datas.push({
                    itemId: item.itemId,
                    categoryId: item.categoryId,
                    itemName: item.itemName,
                    price: item.total,
                    actual: 0,
                    first: item.first,
                    second: item.second,
                    third: item.third,
                    oglPrice: item.price,
                    add: 0,
                    cost: item.cost,
                    itemSign: 0,
                    discount: item.discount,
                    itemVips: item.itemVips,
                    noteId: '',
                    tjType: 0,
                    femp: fEmp,
                    semp: sEmp,
                    temp: tEmp,
                });
                var total = parseFloat(this.total) + parseFloat(item.total)
                this.total = total.toFixed(1)
                this.show = false
            },

            delData(index) {
                let item = this.datas[index];
                this.datas.splice(index, 1)
                var to = parseFloat(this.total) - parseFloat(item.price);
                this.total = to.toFixed(1)
            },
            toMx() {
                if (this.datas.length > 0) {
                    this.mxShow = true
                } else {
                    this.$notify("没添加任何商品!");
                }
            },
            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                    gradeId: this.gradeId,
                }
                let res = await this.$get("/fw/getFwCatItems", data)
                this.list = res.list
                if (res.list.length > 0) {
                    this.items = res.list[0].gwItems
                }
                this.gwJb = res.gwJb
                this.room = res.room
            },

            async saveOrder() {
                this.loading = true
                let mcId = ''
                if (this.mbCard && this.mbCard.id) {
                    mcId = this.mbCard.id
                }
                let memberId = ''
                let orderSex = 1
                if (this.member && this.member.id) {
                    memberId = this.member.id
                    orderSex = this.member.sex
                }
                var data = {
                    taskId: this.taskId,
                    itemStr: JSON.stringify(this.datas),
                    skuStr: '',
                    specStr: '',
                    total: this.total,
                    memberId: memberId,
                    mcId: mcId,
                    orderSex: orderSex,
                    token: this.token,
                    deptId: this.deptId,
                    serviceNo: this.serviceNo
                }
                let res = await this.$post("/sw/saveBillingOrder", data);
                if (res.code == 200) {
                    this.$router.push('/home')
                    // this.loading = false
                    // this.$router.go(-1)
                    // this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },


            toChoose(item) {
                this.show = true
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.total = newItem.price
                if (newItem.discount == 1) {
                    if (this.mbCard && this.mbCard.id) {
                        if (newItem.itemVips.length > 0) {
                            newItem.itemVips.forEach(vip => {
                                if (vip.cardId == this.mbCard.cardId) {
                                    newItem.total = vip.vipPrice;
                                }
                            })
                        } else {
                            //计算会员价
                            if (this.mbCard.itemDiscount != 0) {
                                newItem.total = this.calculationPrice(item.price, this.mbCard.itemDiscount)
                            }
                        }
                    }
                }
                this.item = newItem
                this.getFwEmps()
            },

            async toMdItems() {
                if (!this.member.id) {
                    return;
                }
                this.tcShow = true
                let res = await this.$get("/sw/getSwMemberItems", {memberId: this.member.id});
                this.miNames = res.names
            },
            async toScItems() {
                if (!this.member.id) {
                    return;
                }
                this.scShow = true
                let res = await this.$get("/sw/getSwShopItems", {memberId: this.member.id});
                this.shopNames = res.names
            },
            toTc(item) {
                this.tcempShow = true
                let itemSign = 0
                if (item.miType == 0) {
                    //套餐
                    itemSign = 1
                }
                if (item.miType == 1) {
                    //会员卡
                    itemSign = 2
                }
                if (item.miType == 2) {
                    //年卡
                    itemSign = 3
                }
                if (item.miType == 3) {
                    //单项套餐
                    itemSign = 4
                }
                this.tcItem = {
                    itemId: item.itemId,
                    categoryId: item.categoryId,
                    itemName: item.itemName,
                    price: 0,
                    actual: item.achievement,
                    oglPrice: item.price,
                    itemSign: itemSign,
                    add: 0,
                    discount: 0,
                    noteId: item.id,
                    first: item.fach,
                    second: item.sach,
                    third: item.tach,
                    tjType: 0,
                    femp: {},
                    semp: {},
                    temp: {},
                }
                this.getFwEmps()
            },
            toSc(item) {
                this.tcempShow = true
                let itemSign = 0
                if (item.lyType == 4) {
                    //秒杀套餐
                    itemSign = 5
                }
                if (item.lyType == 10) {
                    //请客卡
                    itemSign = 10
                }
                this.tcItem = {
                    itemId: item.itemId,
                    categoryId: item.categoryId,
                    itemName: item.itemName,
                    price: 0,
                    actual: item.mdAch,
                    oglPrice: item.price,
                    itemSign: itemSign,
                    discount: 0,
                    add: 0,
                    noteId: item.id,
                    first: item.firstAch,
                    second: item.secondAch,
                    third: item.thirdAch,
                    firstCmn: item.firstCmn,
                    secondCmn: item.secondCmn,
                    thirdCmn: item.thirdCmn,
                    tjType: 0,
                    femp: {},
                    semp: {},
                    temp: {},
                }
                this.getFwEmps()
            },
            addTcData() {
                let fEmp = {}
                let sEmp = {}
                let tEmp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            fEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            sEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            tEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                this.tcItem.femp = fEmp
                this.tcItem.semp = sEmp
                this.tcItem.temp = tEmp
                this.datas.push(this.tcItem)
                this.tcempShow = false
                this.guanbi()
            },

            guanbi() {
                this.tcShow = false
                this.scShow = false
            },
            getGwItems(index, cat) {
                this.tabIndex = index
                this.items = cat.gwItems
            },

            async setLEmp(item, type) {
                this.setUnchecked(type);
                item.status = 1
            },
            async setDEmp(item, type) {
                this.setUnchecked(type);
                item.status = 2
            },
            // 将选中的人状态更改为没选中
            setUnchecked(type) {
                if (type == 1) {
                    this.changeEmpFalse(this.fEmps);
                }
                if (type == 2) {
                    this.changeEmpFalse(this.sEmps);
                }
                if (type == 3) {
                    this.changeEmpFalse(this.tEmps)
                }
            },
            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    if (item.status != 0) {
                        item.status = 0
                    }
                })
            },
            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
            //计算价格
            setPrice(item) {
                item.price = item.oglPrice
                if (item.discount == 1) {
                    if (this.mbCard && this.mbCard.id) {
                        if (item.itemVips.length > 0) {
                            item.itemVips.forEach(vip => {
                                if (vip.cardId == this.mbCard.cardId) {
                                    item.price = vip.vipPrice;
                                }
                            })
                        } else {
                            //计算会员价
                            if (this.mbCard.itemDiscount != 0) {
                                item.price = this.calculationPrice(item.price, this.mbCard.itemDiscount)
                            }
                        }
                    }
                }
            },


            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-billing {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
    }

    .fwb-top {
        display: flex;
        flex-direction: column;
    }

    .fwbt-s {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: #eeeeee solid 1px;
    }

    .fwbt-cz {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .fwbt-x {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: #eeeeee solid 1px;
    }

    .fwbt-item {
        height: 46px;
        width: 25%;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-bottom: 5px;
    }

    .fwbt-item1 {
        height: 46px;
        width: 25%;
        display: flex;
        flex-direction: column;
        text-align: center;
        border-left: #eeeeee solid 1px;
    }

    .fwbt-item2 {
        height: 46px;
        line-height: 46px;
        width: 25%;
        text-align: center;
        border-left: #eeeeee solid 1px;
        font-size: 14px;
    }

    .fwbt-t {
        font-size: 14px;
        color: red;
        height: 32px;
        line-height: 32px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .fwbt-t1 {
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }


    .fwbt-b {
        font-size: 11px;
        color: #C4C4C4;
        margin-bottom: 5px;
    }


    .fw-kdtype {
    }

    .fw-gwitems {
        display: flex;
        flex-direction: row;
    }

    .fw-gwitems-f {
        width: 90px;
        display: flex;
        flex-direction: column;
        padding-left: 3px;
    }

    .fw-gwitems-r {
        width: 80%;
        padding: 10px 15px 15px 5px;
    }

    .fw-cats {
        font-size: 13px;
        padding: 10px;
        line-height: 20px;
        margin-bottom: 5px;
        border-left: #ffffff solid 3px;
    }

    .active {
        border-left: #ff4d51 solid 3px;
    }

    .dianzhang {
        width: 100px;
        height: 40px;
    }

    .dianzhang1 {
        width: 100px;
        height: 60px;
        background-color: #ff4d51;
        position: absolute;
        top: 0px;
        left: 6px;
    }

    .fw-leibie {
        height: 35px;
        display: flex;
        flex-direction: row;
    }

    .fw-leibie span {
        width: 25%;
        font-size: 15px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-bottom: #eeeeee solid 1px;
    }

    .lbActive {
        color: #2b94ff;
    }

    .fwgr-item {
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;
        border-bottom: #eeeeee solid 1px;
        align-items: center;
        justify-content: space-between;
    }

    .fwgr-item-info {
        display: flex;
        flex-direction: column;
        padding-left: 5px;
    }

    .fwgr-item-info .mc {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
    }

    .fwgr-item-info .nr {
        font-size: 11px;
        height: 20px;
        line-height: 20px;
        color: #A8A6A6;
    }

    .fwgr-item-info .jg {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
        color: red;
    }

    .fw-btn {
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #ffffff;
    }


    .fw-gw-emps {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 268px;
        border-bottom: #eeeeee solid 1px;
    }

    .emp-gw {
        width: 100%;
        text-align: center;
        border-right: #eeeeee solid 1px;
    }

    .gw {
        display: block;
        height: 30px;
        line-height: 30px;
        border-bottom: #eeeeee solid 1px;
    }

    .fw-gw-emp {
        height: 230px;
        display: flex;
        flex-direction: column;
        padding: 0px 5px;
        overflow: auto;
    }

    .emp {
        height: 20px;
        line-height: 20px;
        text-align: left;
        margin: 5px 0px 0px 5px;
        display: flex;
        flex-direction: row;
    }

    .empname {
        width: 90%;
    }

    .empgl {
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        margin: 0 3px;
        border-radius: 25px;
        color: #ffffff;
        position: relative;
        background-color: #616EB0;
        right: 0px;
    }

    .fw-mx {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-nr {
        display: flex;
        flex-direction: column;
    }

    .fw-mx-items {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        margin-top: 5px;
    }

    .mxemp {
        font-size: 10px;
        padding: 5px 0px;
        color: #999999;
    }

    .fw-mx-item {
        display: flex;
        flex-direction: column;
        background-color: #F7F7F7;
        margin-top: 5px;
        padding: 0 8px;
        padding-bottom: 3px;
    }

    .fwmxi-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 32px;
    }

    .fm-name {
        font-size: 13px;
        width: 45%;
    }

    .fm-jg {
        font-size: 11px;
        width: 25%;
    }

    .fm-num {
        width: 15%;
        font-size: 11px;
    }

    .fm-btn {
        font-size: 12px;
        background-color: red;
        padding: 2px 8px;
        color: #ffffff;
    }

    /deep/ .el-card__header {
        padding: 10px;
        border-bottom: 0.02667rem solid #EBEEF5;
        box-sizing: border-box;
        font-size: 13px;
    }

    .card-item {
        display: flex;
        flex-direction: row;
        font-size: 10px;
    }

    /deep/ .el-card__body {
        padding: 10px;
    }

    .soubtn {
        width: 40px;
        font-size: 14px;
        margin: 0px 3px;
    }

    .tiaozheng {
        margin-top: 5px;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .xiadanjiage {
        font-size: 11px;
        margin-right: 8px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }

    .ki {
        width: 60%;
    }

    .tcmb {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 25px;
        text-align: center;
        font-size: 12px
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .img-mb {
        height: 25px;
        width: 25px
    }

    .tcs {
        font-size: 13px;
        padding: 10px 18px;
    }

    .tcitems {
        margin-top: 5px;
        background-color: #F7F7F7;
        padding: 16px;
    }

    .tcitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        height: 25px;
    }

    .xzbtn {
        width: 30px;
        color: #2b94ff;
    }

    .adddatabtn {
        width: 100%;
        height: 32px;
        font-size: 18px;
        background-color: #2b94ff;
        text-align: center;
        color: #ffffff;
        line-height: 32px;
    }
</style>
